import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useState, Fragment } from "react";
import SideNav from './components/layouts/sideNav';
import Navbar from './components/layouts/navbar';
import Footer from './components/layouts/footer';
import Login from './components/Login';
import Index from './components/Index';
import SuperAssistants from './components/assistants';
import AssociateAssistant from './components/assistants/create';
import AssistantView from './components/assistants/view';
import EditAssistant from './components/assistants/edit';
import { getCookie } from './utils/Cookies';
import Conversations from './components/conversations';
import Conversation from './components/conversations/view';
import Customers from './components/customers';
import CreateCustomer from './components/customers/create';
import CreateUser from './components/user/create';
import User from './components/user';
import Campaigns from './components/campaigns';
import SendCampaign from './components/campaigns/send';
import CreateCampaign from './components/campaigns/create';
import EditCampaign from './components/campaigns/edit';
import Settings from './components/settings';
import EditUser from './components/user/edit';
import EditCustomer from './components/customers/edit';
import Feedback from './components/feedback';
import Playground from './components/playground';
import Flags from './components/flags';
import UploadDoc from './components/indexes/docs/create';
import Indexes from './components/indexes';
import IndexDocument from './components/indexes/docs';
import CreateIndex from './components/indexes/create';
import Tools from './components/tools';
import CreateTool from './components/tools/create';
import EditTool from './components/tools/edit';
import CreateFlag from './components/flags/create';
import SentimentConversations from './components/conversations/sentiments';
import Invoices from './components/invoices';
import EditFLag from './components/flags/edit';
import Download from './components/conversations/downloads';
import CustomerFeedback from './components/customer_feedback';
import './App.css';

function App() {
  const [token, setToken] = useState('');
  const auth = getCookie('token');
  if (!auth) {
    return <Login token={setToken} />;
  }
  else if (token === '') {
    setToken(auth);
  }

  return (
    <Router>
      <Fragment>
        <Navbar />
        <div id="layoutSidenav">
          <SideNav />
          <div id="layoutSidenav_content">
            <Routes>
              <>
                <Route path="/" element={<Index />} />
                <Route path="/super_assistant" element={<SuperAssistants auth={token} />} />
                <Route path="/super_assistant/associate" element={<AssociateAssistant auth={token} />} />
                <Route path="/super_assistant/:assistant_id" element={<AssistantView auth={token} />} />
                <Route path="/super_assistant/edit/:assistant_id" element={<EditAssistant auth={token} />} />
                <Route path="/conversations" element={<Conversations auth={token} />} />
                <Route path="/conversations/:sentiment" element={<SentimentConversations auth={token} />} />
                <Route path="/conversations/downloads" element={<Download auth={token} />} />
                <Route path="/conversation/:id" element={<Conversation auth={token} />} />
                <Route path="/customers" element={<Customers auth={token} />} />
                <Route path="/customers/create" element={<CreateCustomer auth={token} />} />
                <Route path="/customer/:customer_id" element={<EditCustomer auth={token} />} />
                <Route path="/customers_feedback" element={<CustomerFeedback auth={token} />} />
                <Route path="/users" element={<User auth={token} />} />
                <Route path="/users/create" element={<CreateUser auth={token} />} />
                <Route path="/user/:user_id" element={<EditUser auth={token} />} />
                <Route path="/settings" element={<Settings auth={token} />} />
                <Route path="/feedback" element={<Feedback auth={token} />} />
                <Route path="/documents" element={<Indexes auth={token} />} />
                <Route path="/documents/create" element={<CreateIndex auth={token} />} />
                <Route path="/documents/index/:index_id" element={<IndexDocument auth={token} />} />
                <Route path="/documents/create/:index_id" element={<UploadDoc auth={token} />} />
                <Route path="/flags" element={<Flags auth={token} />} />
                <Route path="/playground" element={<Playground auth={token} />} />
                <Route path="/flags/create" element={<CreateFlag auth={token} />} />
                <Route path="/flags/edit/:flag_id" element={<EditFLag auth={token} />} />
                <Route path="/tools" element={<Tools auth={token} />} />
                <Route path="/tool/create" element={<CreateTool auth={token} />} />
                <Route path="/tool/edit/:tool_id" element={<EditTool auth={token} />} />
                <Route path="/invoices" element={<Invoices auth={token} />} />
                <Route path="/campaigns" element={<Campaigns auth={token} />} />
                <Route path="/campaigns/send" element={<SendCampaign auth={token} />} />
                <Route path="/campaigns/create" element={<CreateCampaign auth={token} />} />
                <Route path="/campaigns/edit/:campaign_id" element={<EditCampaign auth={token} />} />
              </>
            </Routes>
            <Footer />
          </div>
        </div>
      </Fragment>
    </Router>
  );
}

export default App;
